import * as React from "react";

import { ThemeProvider } from "@mui/material/styles";
import Header from "../components/Header";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { sections } from "../config";
import Footer from "../components/Footer";
import { graphql } from "gatsby";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TagIcon from "@mui/icons-material/Tag";
import LabelIcon from "@mui/icons-material/Label";
import CategoryList from "../components/category-list";
import CBreadcrumb from "../components/CBreadcrumb";
import Author from "../components/Author";
import { theme } from "../components/theme";
import { SEO } from "../components/HeadMeta";
import HubspotSubscribeForm from "../components/HubspotSubscribeForm";

export const Head = ({ data }) => {
    return (
        <SEO
            title={data.post.frontmatter.title}
            description={data.post.excerpt || data.post.frontmatter.description}
            pathname={data.post.fields.path}
            image={
                data.post.frontmatter?.coverImage?.childImageSharp
                    ?.gatsbyImageData.images.fallback.src
            }
            imageWidth={
                data.post.frontmatter?.coverImage?.childImageSharp
                    ?.gatsbyImageData.width
            }
            imageHeight={
                data.post.frontmatter?.coverImage?.childImageSharp
                    ?.gatsbyImageData.height
            }
        />
    );
};

const Page = ({ data }) => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Container maxWidth="lg">
                <Header title="Blog" sections={sections} />
                <CBreadcrumb title={data.post.frontmatter.title} date={data.post.frontmatter.created} />
                <Grid container>
                    <Grid item xs={0} md={2}></Grid>
                    <Grid item xs={12} md={8}>
                        <main>
                            <CategoryList
                                icon={<LabelIcon />}
                                items={data.post.frontmatter.categories}
                                baseUrl="/category"
                            />

                            <Typography
                                variant="h2"
                                component="h2"
                                gutterBottom
                            >
                                {data.post.frontmatter.title}
                            </Typography>

                            <Grid item xs={12}>
                                <Author
                                    author={data.post.frontmatter.authors[0]}
                                />
                            </Grid>

                            <div
                                dangerouslySetInnerHTML={{
                                    __html: data.post.html,
                                }}
                            />

                            <CategoryList
                                icon={<TagIcon />}
                                items={data.post.frontmatter.tags}
                                baseUrl="/tag"
                            />

                            <hr />
                            <HubspotSubscribeForm />
                        </main>
                    </Grid>
                </Grid>
            </Container>
            <Footer />
        </ThemeProvider>
    );
};

export const query = graphql`
    query BlogPost($path: String!) {
        post: markdownRemark(fields: { path: { eq: $path } }) {
            html
            fields {
                path
            }
            excerpt
            frontmatter {
                categories
                tags
                title
                created
                coverImage {
                    childImageSharp {
                        gatsbyImageData(width: 200)
                    }
                }
                authors {
                    frontmatter {
                        name
                        id
                        bylinebio
                        coverImage {
                            childImageSharp {
                                gatsbyImageData(width: 400)
                            }
                        }
                    }
                    html
                }
            }
        }
    }
`;
export default Page;
